<template>
  <div id="app">
    <headers></headers>
    <router-view :key="$route.fullPath"></router-view>
    <footers></footers>
    <div class="scroll-to-book" @click.stop="scrollBook">訂</div>
    <div class="scroll-to-top" @click.stop="scrollTop">TOP</div>
  </div>
</template>

<script>
import Vue from 'vue'
// import Headers from '@/components/Header'
// import Footers from '@/components/Footer'
import Headers from '@/components/HeaderV2'
import Footers from '@/components/FooterV2'

/**
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDr2rHAauOjDzHMp3iOnEBLJDgR8t68LTU',
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})
 */

import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel)

require('swiper/dist/css/swiper.css')
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

import VuePlayerPlugin from 'vue-youtube-iframe-api'
Vue.use(VuePlayerPlugin)

import VueProgressiveImage from 'vue-progressive-image'
Vue.use(VueProgressiveImage, {
  blur: 30,
  delay: 10
})

require('aos/dist/aos.css')
import AOS from 'aos'
Vue.use(AOS)
AOS.init()

export default {
  name: 'app',
  components: {Headers, Footers},
  computed: {
    showScrollTop () {
      return document.body.scrollTop > 300
    }
  },
  methods: {
    scrollTop () {
      window.scroll({top: 0, left: 0, behavior: 'smooth'})
    },
    scrollBook () {
      this.$ga.event('reserve', 'click-small-reserve', 'online', 1)
      var element = this.$children[1].$refs['toBookEntry']

      if (element) {
        var top = element.offsetTop
        window.scroll({top: top, left: 0, behavior: 'smooth'})
        // window.scrollTo(0, top)
      } else {
        this.$router.push({name: 'Hello', hash: '#toBookEntry'})
      }
    }
  }
}
</script>

<style lang="scss">

@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);
@import url('https://fonts.googleapis.com/css?family=Josefin+Slab|Lobster');
// @import './assets/styles/style.css';

// Bootstrap CSS
// @import './assets/css/bootstrap.css';
// @import './assets/vendors/linericon/style.css';
// @import './assets/vendors/bootstrap-datepicker/bootstrap-datetimepicker.min.css';
// @import './assets/vendors/nice-select/css/nice-select.css';
// @import './assets/vendors/owl-carousel/owl.carousel.min.css';

// main css
// @import './assets/css/style.css';
// @import './assets/css/responsive.css';


#app {
  font-family: 'Noto Sans TC', 'Josefin Slab', 'Avenir', Helvetica, Arial, sans-serif;
  /* font-family: 'Josefin Slab', serif; */
  /* font-family: 'Lobster', cursive; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  overflow-x: hidden;
}
.scroll-to-top {
  z-index: 3;
  cursor: pointer;
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: rgba(255,255,255,.8);
  color: brown;
  font-weight: 800;
  line-height: 50px;
  border: 2px solid brown;
  // box-shadow: 0px 2px 5px rgba(0, 0, 0, .5);
}
.scroll-to-book {
  z-index: 3;
  cursor: pointer;
  position: fixed;
  bottom: 100px;
  right: 35px;
  width: 40px;
  height: 40px;
  background: #54b4b4;
  color: white;
  font-weight: 800;
  line-height: 40px;
  border: 1px solid #ffffff;
  box-shadow: 0 0 0 5px #54b4b4;
}
  ::-webkit-scrollbar-track {
	  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	  background-color: #F5F5F5;
  }

  ::-webkit-scrollbar
  {
	  width: 10px;
	  background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb
  {
	  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	  background-color: black;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue